/**
 * Lightweight Dokument-Runtime-Konstanten.
 *
 * Diese Datei darf von Start-/Sync-Pfaden statisch importiert werden, ohne
 * dadurch pdf-lib/pdf.js und die eigentliche Dokument-Renderpipeline in den
 * initialen PWA-Bundlegraphen zu ziehen.
 */
export const WITHDRAWAL_DOCUMENT_ARTIFACT_VERSION = "document-artifacts-v6-flattened-firefox-compatible";
